import styled from "styled-components";
import React, { useEffect } from "react";
import { useState } from "react";

import { IonIcon } from "@ionic/react";
import {
  barChartOutline,
  barChart,
  documentTextOutline,
  documentText,
  chatbubbles,
  chatbubblesOutline,
  informationCircle,
  informationCircleOutline,
  flashOutline,
  flash,
  cogOutline,
  cog,
} from "ionicons/icons";
import { useNavigate, useLocation } from "react-router-dom";

const DesktopNavWrapper = styled.div`
  position: fixed;
  left: 0;
  top: 85px;
  height: 100%;
  width: 200px;
  padding: 15px 0 15px 15px;
  gap: 15px;
  z-index: 9;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: #ffffffdf;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  -webkit-box-shadow: 0px -2px 16px -6px #000000;
  box-shadow: 0px -2px 16px -6px #000000;
  @media (max-width: 800px) {
    display: none;
  }
`;

const DesktopNavOption = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  transition: color 0.2s ease-in-out;
  -webkit-tap-highlight-color: white;
  -webkit-focus-ring-color: white;
  height: calc(24px+4px+11px);
  cursor: pointer;

  ion-icon {
    height: 24px;
    width: 24px;
    transition: color 0.2s ease-in-out;
  }
  p {
    margin-left: 10px;
    font-size: 13px;
    transition: color 0.2s ease-in-out;
    user-select: none;
  }
`;

function DesktopNav() {
  const [pageName, setPageName] = useState<string>("dashboard");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.split("/");
    const pageName = path[path.length - 1];
    setPageName(pageName);
  }, [location]);

  return (
    <DesktopNavWrapper>
      <DesktopNavOption onClick={() => navigate("/overview")}>
        <IonIcon
          icon={pageName.includes("overview") ? barChart : barChartOutline}
          size="large"
          style={{
            color: pageName.includes("overview")
              ? "var(--accent-color-dark)"
              : "black",
          }}
        />
        <p
          style={{
            color: pageName.includes("overview")
              ? "var(--accent-color-dark)"
              : "black",
          }}
        >
          Overview
        </p>
      </DesktopNavOption>
      <DesktopNavOption onClick={() => navigate("/reports")}>
        <IonIcon
          icon={
            location.pathname.split("/", 2).includes("reports")
              ? documentText
              : documentTextOutline
          }
          size="large"
          style={{
            color: location.pathname.split("/", 2).includes("reports")
              ? "var(--accent-color-dark)"
              : "black",
          }}
        />
        <p
          style={{
            color: location.pathname.split("/", 2).includes("reports")
              ? "var(--accent-color-dark)"
              : "black",
          }}
        >
          My Reports
        </p>
      </DesktopNavOption>
      <DesktopNavOption onClick={() => navigate("/stories")}>
        <IonIcon
          icon={
            location.pathname.split("/", 2).includes("stories")
              ? chatbubbles
              : chatbubblesOutline
          }
          size="large"
          style={{
            color: location.pathname.split("/", 2).includes("stories")
              ? "var(--accent-color-dark)"
              : "black",
          }}
        />
        <p
          style={{
            color: location.pathname.split("/", 2).includes("stories")
              ? "var(--accent-color-dark)"
              : "black",
          }}
        >
          Stories
        </p>
      </DesktopNavOption>
      {/*   <DesktopNavOption onClick={() => navigate("/cheatsheets")}>
        <IonIcon
          icon={
            location.pathname.split("/", 2).includes("cheatsheets")
              ? flash
              : flashOutline
          }
          size="large"
          style={{
            color: location.pathname.split("/", 2).includes("cheatsheets")
              ? "var(--accent-color-dark)"
              : "black",
          }}
        />
        <p
          style={{
            color: location.pathname.split("/", 2).includes("cheatsheets")
              ? "var(--accent-color-dark)"
              : "black",
          }}
        >
          Cheat Sheets
        </p>
      </DesktopNavOption> */}
      <DesktopNavOption onClick={() => navigate("help")}>
        <IonIcon
          icon={
            location.pathname.split("/", 2).includes("help")
              ? informationCircle
              : informationCircleOutline
          }
          size="large"
          style={{
            color: location.pathname.split("/", 2).includes("help")
              ? "var(--accent-color-dark)"
              : "black",
          }}
        />
        <p
          style={{
            color: location.pathname.split("/", 2).includes("help")
              ? "var(--accent-color-dark)"
              : "black",
          }}
        >
          Help
        </p>
      </DesktopNavOption>
    </DesktopNavWrapper>
  );
}

export default React.memo(DesktopNav);
